var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex flex-col justify-between flex-grow h-full gap-2" },
    [
      _c(
        "div",
        {
          staticClass:
            "flex flex-col items-center content-center justify-center flex-grow-0 h-full transition-all gap-x-3",
          class: { "gap-y-4": !_vm.isCollapsed, "gap-y-2": _vm.isCollapsed }
        },
        [
          _c(
            "div",
            { staticClass: "grid items-center grid-cols-5" },
            [
              _c("BlTextTitle2", {
                staticClass: "flex justify-center transition-all duration-300",
                class: [_vm.isStarted ? "text-slate-800" : "text-slate-600"],
                attrs: { text: _vm.timer.split(":")[0] }
              }),
              _vm._v(" "),
              _c("BlTextTitle2", {
                staticClass:
                  "flex justify-center pb-2 transition-all duration-300",
                class: [_vm.isStarted ? "text-slate-800" : "text-slate-600"],
                attrs: { text: ":" }
              }),
              _vm._v(" "),
              _c("BlTextTitle2", {
                staticClass: "flex justify-center transition-all duration-300",
                class: [_vm.isStarted ? "text-slate-800" : "text-slate-600"],
                attrs: { text: _vm.timer.split(":")[1] }
              }),
              _vm._v(" "),
              _c("BlTextTitle2", {
                staticClass:
                  "flex justify-center pb-2 transition-all duration-300",
                class: [_vm.isStarted ? "text-slate-800" : "text-slate-600"],
                attrs: { text: ":" }
              }),
              _vm._v(" "),
              _c("BlTextTitle2", {
                staticClass: "flex justify-center transition-all duration-300",
                class: [_vm.isStarted ? "text-slate-800" : "text-slate-600"],
                attrs: { text: _vm.timer.split(":")[2] }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("BlInputButton", {
            staticClass: "w-full rounded-3xl",
            class: { "pointer-events-none": _vm.sessionStatus !== "ongoing" },
            attrs: {
              label: _vm.isStarted ? "Stop timer" : "Start timer",
              loading: _vm.updateLoading
            },
            on: {
              clicked: function($event) {
                return _vm.$emit("toggle-timer")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isCollapsed
        ? _c(
            "div",
            { staticClass: "flex-shrink-0 pb-3 text-center" },
            [
              _c("BlTextBody2", { attrs: { text: "Goal:" } }),
              _vm._v(" "),
              _vm.measurement.target.success_metric ===
              "equal to or greater than goal"
                ? _c("BlTextBody2", { attrs: { text: "≥" } })
                : _vm._e(),
              _vm._v(" "),
              _vm.measurement.target.success_metric === "less than goal"
                ? _c("BlTextBody2", { attrs: { text: "<" } })
                : _vm._e(),
              _vm._v(" "),
              _c("BlTextBody2", {
                attrs: { text: _vm.measurement.target.goal_time }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8387ed1e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8387ed1e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sessions/card/Duration.vue
// module id = null
// module chunks = 